import { render, staticRenderFns } from "./SeriesDeleteModal.vue?vue&type=template&id=39943856&scoped=true&"
import script from "./SeriesDeleteModal.vue?vue&type=script&lang=js&"
export * from "./SeriesDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39943856",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39943856')) {
      api.createRecord('39943856', component.options)
    } else {
      api.reload('39943856', component.options)
    }
    module.hot.accept("./SeriesDeleteModal.vue?vue&type=template&id=39943856&scoped=true&", function () {
      api.rerender('39943856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Series/SeriesDeleteModal.vue"
export default component.exports